<template lang="pug"></template>

<script>
export default {
    name: 'BotaoLaudos',
    componentOptions: {
        title: 'Laudos',
        actions: [
            [
                {
                    name: 'Laudos',
                    iconClass: 'lyra-icon lyra-laudos',
                    showView: false,
                    action: 'abrirLaudos',
                    route: 'Laudos'
                }
            ]
        ]
    },

    methods: {
        abrirLaudos() {
            if (this.$route.name !== 'Laudo') {
                this.$router.push({ name: 'Laudo' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
